'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _onSubmit = require('./on-submit');

var _onSubmit2 = _interopRequireDefault(_onSubmit);

var _onSuccess = require('./on-success');

var _onSuccess2 = _interopRequireDefault(_onSuccess);

var _onError = require('./on-error');

var _onError2 = _interopRequireDefault(_onError);

var _defaultProps = require('./default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NetlifyForm = function (_React$Component) {
	(0, _inherits3.default)(NetlifyForm, _React$Component);

	function NetlifyForm(props) {
		(0, _classCallCheck3.default)(this, NetlifyForm);

		var _this = (0, _possibleConstructorReturn3.default)(this, (NetlifyForm.__proto__ || Object.getPrototypeOf(NetlifyForm)).call(this, props));

		_this.state = {
			error: false,
			loading: false,
			success: false
		};
		_this.onSubmit = _onSubmit2.default.bind(_this);
		_this.onSuccess = _onSuccess2.default.bind(_this);
		_this.onError = _onError2.default.bind(_this);
		return _this;
	}

	(0, _createClass3.default)(NetlifyForm, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'form',
				{
					ref: function ref(el) {
						return _this2.form = el;
					},
					onSubmit: this.onSubmit,
					name: this.props.name,
					action: this.props.action,
					'data-netlify': 'true',
					'data-netlify-honeypot': this.props.honeypotName
				},
				_react2.default.createElement('input', {
					type: 'hidden',
					name: 'form-name',
					value: this.props.name
				}),
				_react2.default.createElement('input', {
					ref: function ref(el) {
						return _this2.honeypot = el;
					},
					type: 'text',
					name: this.props.honeypotName,
					style: {
						display: 'none'
					}
				}),
				this.props.children(this.state)
			);
		}
	}]);
	return NetlifyForm;
}(_react2.default.Component);

NetlifyForm.defaultProps = _defaultProps2.default;

exports.default = NetlifyForm;
module.exports = exports['default'];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-netlify-form/dist/index.js
// module id = 1013
// module chunks = 168707334958949